<template>
  <div class="content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="dialogVisible = true"
      >新建节目单</el-button
    >
    <el-table :data="tableData">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="programName" label="名称"></el-table-column>
      <el-table-column label="屏幕分配">
        <template slot-scope="scope">
          <i
            class="el-icon-upload2 pointer"
            @click="openSend(scope.row)"
            title="屏幕分配"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="添加时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i
            class="el-icon-edit pointer mar-r10"
            @click="(loading = true), openEdit(scope.row)"
          ></i>
          <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!-- 新增节目单 -->
    <el-dialog
      class="big-dialog"
      title="新增节目单"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <add-program 
        ref="addprogram" 
        @closeMethod="closeAdd"
      ></add-program>
    </el-dialog>

    <el-dialog
      class="big-dialog"
      title="修改节目单"
      :visible.sync="editVisible"
      v-if="editVisible"
    >
      <edit-program
        :editData="editData"
        ref="editprogram"
        @closeMethod="closeEdit"
        @closeLoading="closeLoading"
      ></edit-program>
    </el-dialog>

    <el-dialog
      class="dialog800"
      :title="'节目单分配['+sendData.programName+']'"
      :visible.sync="sendVisible"
      v-if="sendVisible"
    >
      <send-program
        :sendData="sendData"
        ref="sendprogram"
        @closeMethod="closeSend"
      ></send-program>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import addProgram from "@/components/message/program/addProgram.vue"
import editProgram from "@/components/message/program/editProgram.vue"
import sendProgram from "@/components/message/program/sendProgram.vue"
export default {
  components: { 
    addProgram,
    editProgram,
    sendProgram
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      dialogVisible: false,
      editVisible: false,
      editData: {
        id: null,
        type: 1,
        title: "",
        ste: null,
        uid: null,
        is_double: null,
        stg: []
      },
      sendVisible: false,
      sendData: {
        stg_id: null,
        type: 1,
        stg_name: '',
        is_double: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/programGuides/manager/listPage',
        method: 'GET',
        params: {
          fileName: '',
          pageNum: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize
        },
      }).then(res => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.pageCount);
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openSend(value) {
      let sendParams = { 
        id: value.id, 
        programName: value.programName, 
        deviceCode: value.deviceCode
      }
      this.sendVisible = true
      this.sendData = sendParams
    },
    closeSend() {
      this.sendVisible = false
      this.sendData = {
        id: null,
        programName: '',
        deviceCode: ''
      }
      this.getTableData(this.pageInfo.page);
    },
    closeAdd() {
      this.dialogVisible = false
      this.getTableData(this.pageInfo.page);
    },
    openEdit(program) {
      this.editVisible = true
      this.editData = program
    },
    closeEdit() {
      this.editVisible = false
      this.editData = {
        id: null,
        programName: '',
        time: '',
        fileId: '',
        status: 0
      }
      this.getTableData(this.pageInfo.page);
    },
    closeLoading(){
      this.loading = false
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios({
            url: process.env.VUE_APP_BASE_API+'/v1/programGuides/manager/deleteProgramData',
            method: 'post',
            data: qs.stringify({id:id})
          }).then(res => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style scoped>
.new-program {
  display: inline-block;
  margin-top: 20px;
}
.pointer {
  cursor: pointer;
}
.lamp-refresh {
  top: -10px;
}
</style>
